
























































import { Vue, Watch, Component, Prop } from 'vue-property-decorator'
import Banner from '@/components/Banner.vue'
import NewYears from './newYears.vue'
import CommendNews from './commendNews.vue'
import NewsListLink from './newsListLink.vue'

@Component({
  components: {
    Banner,
    NewYears,
    CommendNews,
    NewsListLink
  }
})
export default class News extends Vue {
  // page = 1
  total = 0 // 数据总条数
  pagesize = 10 // 一页显示10条
  currentPage = 1 // 当前页
  listOrder = 1 // 排序方向， 默认值是1＝从小到大;-1=从大到小
  navigation = [
    {
      text: '首页',
      path: '/'
    },
    {
      text: '新闻',
      path: '/news'
    },
    {
      text: '年份',
      path: '/news'
    },
    {
      text: '平台动态',
      path: ''
    }
  ]
  lists = []
  years:any = []
  recommendNews = []
  created () {
    this.changeRoute()
  }
  get pages () { // 总页数
    return Math.ceil(this.total * 1 / this.pagesize)
  }
  // 显示页码条
  get show () {
    return this.pages && this.pages !== 1
  }
  // 限制上一页不能点击
  get pstart () {
    return this.currentPage === 1
  }
  // 限制下一页不能点击
  get pend () {
    return this.currentPage === this.pages
  }
  // ...的显示
  get efont () {
    if (this.pages <= 7) return false
    return this.currentPage > 5
  }
  // ...的隐藏
  get ebehind () {
    if (this.pages <= 7) return false
    var nowAy = this.indexs
    return nowAy[nowAy.length - 1] !== this.pages
  }
  /* eslint-disable */
    // 一共有多少页
  get indexs () {
    var left = 1
    var right = this.pages
    var ar = []
    if (this.pages >= 7) {
      if (this.currentPage > 5 && this.currentPage < this.pages - 4) {
        left = Number(this.currentPage) - 3
        right = Number(this.currentPage) + 3
      } else {
        if (this.currentPage <= 5) {
          left = 1
          right = 7
        } else {
          right = this.pages
          left = this.pages - 6
        }
      }
    }
    while (left <= right) {
      ar.push(left)
      left++
    }
    return ar
  }
  /* eslint-disable */
  // 年份
  get queryYear () {
    let year = this.$route.query.year
    return year
  }
  // catkey
  get queryCatKey () {
    let catKey = this.$route.query.catKey
    return catKey
  }
  get category () {
      return '平台动态'
    // if (this.queryCatKey == 'com_news') {
    //   return '平台动态'
    // } else if (this.queryCatKey == 'com_dynamic') {
    //   return '合作动态'
    // } else {
    //   return '产品发展'
    // }
  }
  mounted () {
    this.initIndex()
    this.initListData()
    console.log('queryYear, queryCatKey', this.queryYear, this.queryCatKey)
  }
  // 时间
  getTime (time:any) {
    return time.split('T')[0].split('-').join('/')
  }
  // 点击年份
  changedYear (year:string) {
    console.log('queryYear, queryCatKey', this.queryYear, this.queryCatKey)
    console.log('year=====》》》》》', year)
    this.currentPage = 1
    this.$router.push({ path: '/news/list', query: { year: year, catKey: this.queryCatKey } })
    this.initIndex()
    this.initListData()
  }
  // 初始化首页数据
  initIndex () {
    let params = {}
    if (this.queryYear) {
      if (this.queryYear === '全部') {
        params = {
          pub_year: ''
        }
      } else {
        params = {
          pub_year: this.queryYear
        }
      }
    } else {
      params = {
        pub_year: ''
      }
    }
    console.log('新闻页面首页params', params)
    this.$store.dispatch('getNewsIndex', params).then(res => {
      console.log('新闻页面首页', res)
      this.years = res.news.years
      this.years.unshift('全部')
      console.log('years', this.years)
      this.recommendNews = res.news.recommendNews.news
      console.log('recommendNews', this.recommendNews)
    })
  }
  // 初始化列表
  initListData () {
    let params = {}
    if (this.queryYear === '全部') {
      params = {
        page: this.currentPage,
        category: this.queryCatKey,
        pub_year: ''
      }
    } else {
      params = {
        page: this.currentPage,
        category: this.queryCatKey,
        pub_year: this.queryYear
      }
    }
    console.log('params更多新闻列表返回', params)
    this.$store.dispatch('getNewList', params).then(res => {
      console.log('更多新闻列表返回', res)
      this.lists = res.news.list
      this.total = res.news.allNum
      console.log('更多新闻列表返回====>', this.lists)
    })
  }
  // 进入详情
  newsDetail (item:any) {
    console.log('item', item)
    this.$router.push({ path: '/news/detail', query: { year: this.queryYear, id: item.id } })
  }
  // 前端加分页调用的方法
  jumpPage (num:any) {
    console.log('this.currentPage', this.currentPage)
    this.currentPage = num
    console.log('currentPage', this.currentPage)
    this.initListData()
  }
  // 点击上一页
  jumpOnPage () {
    this.currentPage--
    this.initListData()
  }
  // 点击下一页
  jumpDowPage () {
    this.currentPage++
    this.initListData()
  }
  @Watch('$route')
  onRouteChanged () {
    this.changeRoute()
  }
  changeRoute () {
    console.log(this.$route)
    this.navigation.forEach((item:any, index:number) => {
      if (item.path === '') {
        item.text = this.category
      }
      if (index == 2) {
        item.text = this.queryYear
        item.path = '/news?year=' + this.queryYear
      }
    })
  }
}
